<template>
	<page>
		<module>
			<view-list ref="view" work-type="36" selector :view-config="auth('b_customer_viewmanage')">
				<template #search>
					<m-search ref="search">
						<m-search-item label="客户信息">
							<c-input name="keyword"></c-input>
						</m-search-item>
						<m-search-item label="联系人">
							<c-input name="contact_name"></c-input>
						</m-search-item>
						<m-search-item label="联系电话">
							<c-input name="contact_phone"></c-input>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button color="main" v-if="auth('b_sale_customer_edit')" prepend-icon="tf-add" @click="editCustomer()">新建客户</c-button>
					<c-button v-if="auth('b_sale_customer_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
				</template>
                <!--授信余额-->
                <template #credit_balance="{data}">
                    ￥{{data.credit_balance||'0.00'}}
                </template>
                <!--已用授信额度余额-->
                <template #credit_used="{data}">
                    ￥{{data.credit_used||'0.00'}}
                </template>

				<c-table-column
					type="button"
					label="操作"
					width="110"
					button-limit="6"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_sale_customer_edit')" icon="tf-edit" @click="editCustomer(data)">编辑</c-table-button>
					</template>
				</c-table-column>
			</view-list>
		</module>
	</page>
</template>

<script>
	export default {
		methods: {
			/******新建/编辑客户：新建时按当前视图预置客户类型*******/
			editCustomer(data) {
				this.globalDialog('saleCustomerEdit', {
					data: data,
					props: {
						default_customer_type: this.defaultCustomerTypeByView()
					}
				}, this.$refs.view.update);
			},

			/******按当前视图ID映射新建客户的默认勾选类型：800401零售客户视图→2，800402同行客户视图→1；其他视图不预置*******/
			defaultCustomerTypeByView() {
				var viewId = this.$refs.view.getViewId();
				if (viewId == 800401) return 2;
				if (viewId == 800402) return 1;
				return null;
			},
		}
	}
</script>

<style lang="stylus" scoped>
</style>
